/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { blockHeightsOverTimeGetApiV3BlockHeightsOverTime } from "../../funcs/blockHeightsOverTimeGetApiV3BlockHeightsOverTime.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3BlockHeightsOverTimeRequest$inboundSchema,
};

export const tool$blockHeightsOverTimeGetApiV3BlockHeightsOverTime:
  ToolDefinition<typeof args> = {
    name: "block-heights-over-time-get-api-v3-block-heights-over-time",
    description: ``,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await blockHeightsOverTimeGetApiV3BlockHeightsOverTime(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
